import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/modules/shared.module';
import { MentionComposerComponent } from './mention-composer.component';

@NgModule({
  declarations: [MentionComposerComponent],
  imports: [SharedModule],
  exports: [MentionComposerComponent],
})
export class MentionComposerModule {}
